<!------------ START TEMPLATE ------------>
<template>
  <div>
    <UsersFilter
      @submit="updateFilters"
      @export="exportXls"
      :subjectPermission="subjectPermission"
    />
    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <add-new-data-sidebar
          :isSidebarActive="addNewDataSidebar"
          @closeSidebar="addNewDataSidebar = false"
          :form="formSideBar"
          :title="titleSideBar"
          :dados="dadosSideBar"
          @concluido="concluido"
        />

        <vs-table
          noDataText="Nenhum Usuário Encontrado"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :max-items="itemsPerPage"
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div class="flex flex-wrap-reverse items-center">
              <!------------ START  MENU DE AÇÕES ------------>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2">Ações</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="inativar"
                    v-if="$can($actionsDefault.Inativar, subjectPermission)"
                  >
                    <span>Inativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="reativar"
                    v-if="$can($actionsDefault.Inativar, subjectPermission)"
                  >
                    <span>Reativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="imprimir">
                    <span>Imprimir</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <!------------ END MENU DE AÇÕES ------------>

              <!------------ START ADD NOVO USUÁRIO ------------>
              <div
                class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-primary border border-solid border-primary"
                @click="openSideBar()"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary"
                  >Adicionar novo Usuário</span
                >
              </div>
            </div>
            <!------------ END ADD NOVO USUÁRIO ------------>

            <div class="flex">
              <!------------ START ITENS POR PÁGINA ------------>
              <SelectPagination
                v-if="itens.length > 0"
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :length="count"
                @update="updateSelectPagination"
              />
              <!------------ END ITENS POR PÁGINA ------------>
            </div>
          </div>

          <!------------ START TITULO DA TABELA ------------>

          <template slot="thead">
            <vs-th sort-key="Nome">Nome</vs-th>
            <vs-th sort-key="Usuario">Email</vs-th>
            <vs-th sort-key="Usuario">Empresa</vs-th>
            <vs-th sort-key="Usuario">Nome da Empresa</vs-th>
            <vs-th sort-key="Status">Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <!------------ END TITULO DA TABELA ------------>

          <!------------ START TABELA ------------>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <vs-list-item :title="tr.name" :subtitle="tr.sectorName">
                    <template slot="avatar">
                      <vs-avatar />
                    </template>
                  </vs-list-item>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.email }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ getCompanyType(tr) }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.brokerName || tr.covenantName || tr.consultancyName }}
                  </p>
                </vs-td>

                <vs-td>
                  <vs-chip
                    :color="getStatusColor(tr.deletedAt)"
                    class="product-order-status"
                    >{{ getStatusString(tr.deletedAt) }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col">
                      <vs-button
                        v-tooltip="'Detalhes do Usuário'"
                        radius
                        color="dark"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-search"
                        class="d-inline"
                        @click="opemModal(tr.id)"
                      ></vs-button>
                    </div>
                    <div
                      class="vx-col"
                      v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    >
                      <vs-button
                        v-tooltip="'Editar Usuário'"
                        radius
                        color="success"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="d-inline"
                        @click="openSideBar(tr.id)"
                      ></vs-button>
                    </div>
                    <div class="vx-col">
                      <vs-button
                        radius
                        v-tooltip="'Histórico de Alterações'"
                        color="#88abc2"
                        icon-pack="feather"
                        icon="icon-archive"
                        class="d-inline"
                        @click="abrirModalHistoricoUsuarios(tr)"
                      ></vs-button>
                    </div>
                    <div
                      class="vx-col"
                      v-if="$can('Reset de Senha', subjectPermission)"
                    >
                      <vs-button
                        radius
                        v-tooltip="'Resetar Senha'"
                        color="warning"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-lock"
                        class="d-inline"
                        @click="openModalSenha(tr)"
                      ></vs-button>
                    </div>
                    <div class="vx-col">
                      <vs-button
                        radius
                        v-tooltip="'Código de Acesso'"
                        color="primary"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-hash"
                        class="d-inline"
                        @click="openModalCodigoAcesso(tr.accessCode)"
                      ></vs-button>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <div class="mt-6">
          <vs-pagination
            :total="parseInt(count / itemsPerPage) + 1"
            v-model="currentPage"
          ></vs-pagination>
        </div>

        <!------------ END TABELA ------------>

        <!------------ START INFORMAÇÕES DO USUÁRIO ------------>
        <ModalInfo
          :modalSelecionado="modalSelecionado"
          :popupActive="popupActive"
          :title="`Dados do ${entidade}`"
          @close="popupActive = false"
        ></ModalInfo>

        <Modal
          v-if="userAlteracao"
          class="holamundo"
          :title="'Reset de Senha'"
          :active.sync="modalSenha"
          @close="modalSenha = false"
        >
          <p class="mb-base">
            Uma senha temporária será enviada para
            <strong>{{ userAlteracao.email }}</strong>. No próximo login, o
            usuário deverá alterá-la.
          </p>
          <div class="flex justify-end">
            <vs-button color="success" @click="resetSenha()"
              >Confirmar
            </vs-button>
          </div>
        </Modal>

        <Modal
          class="holamundo"
          :title="'Código de Acesso'"
          :active.sync="modalCodigoAcesso"
          @close="modalCodigoAcesso = false"
        >
          {{ this.codigoAcesso }}
        </Modal>
        <!------------ END INFORMAÇÕES DO USUÁRIO ------------>

        <ModalHistoricoAlteracoes
          :popupActive="popupAlteracoesActive"
          :tipo="tipoHistorico"
          :nome="nomeHistorico"
          :dadosConsulta="dadosConsultaHistorico"
          @close="fecharModalHistorico"
        ></ModalHistoricoAlteracoes>
      </div>
    </vx-card>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import ModalInfo from '../../components/ModalInfo';
import AddNewDataSidebar from './../Includes/SideBar';

import SelectPagination from '@/utils/list/header/SelectPagination.vue';
import UsersFilter from '@/views/filtros/UsersFilter.vue';
import Modal from '../../components/Modal.vue';
import service from '../../services';
import userApi from '../../services/user.api.js';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalHistoricoAlteracoes from '../modais/ModalHistoricoAlteracoes.vue';
import { COMPANY_TYPE_LABEL } from '../../constants/company.type.constant.js';

export default {
  components: {
    SelectPagination,
    UsersFilter,
    AddNewDataSidebar,
    ModalInfo,
    ModalHistoricoAlteracoes,
    Modal,
  },
  props: ['subjectPermission'],
  data() {
    return {
      codigoAcesso: null,
      dadosSideBar: {},
      controllerGeral: 'Usuario',
      formSideBar: 'usuario',
      entidade: 'Usuário',
      titleSideBar: 'Adicionar Usuario',
      popupActive: false,
      popupAlteracoesActive: false,
      modalSenha: false,
      modalCodigoAcesso: false,
      modalSelecionado: [],
      userAlteracao: null,
      selected: [],
      itens: [],
      itemsPerPage: 50,
      currentPage: 1,
      count: 0,
      addNewDataSidebar: false,
      dominios: {
        perfis: [],
        setores: [],
        escritorios: [],
      },
      userSearched: null,
      debounce: functions.debounce(this.buscaDados, 1000),
      dadosConsultaHistorico: [],
      tipoHistorico: 'Usuarios',
      nomeHistorico: '',
      filters: {},
      cachedUsersDetails: {},
    };
  },
  computed: {},
  watch: {
    currentPage() {
      this.buscaDados();
    },
    itemsPerPage() {
      this.buscaDados();
    },
    userSearched: {
      handler: function () {
        this.debounce();
      },
    },
  },
  methods: {
    getCompanyType(user) {
      if (user.brokerId) return COMPANY_TYPE_LABEL.BROKER;
      if (user.covenantId) return COMPANY_TYPE_LABEL.COVENANT;
      if (user.consultancyId) return COMPANY_TYPE_LABEL.CONSULTANCY;
    },
    async exportXls() {
      const params = functions.cleanParams(this.filters);
      try {
        const response = await userApi.exportUsersXls(params);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Usuários - ${now}.xlsx`;

        await functions.downloadFromBuffer(window, response, fileName);
      } catch (e) {
        notify.notifyFail(this.$vs, e);
      }
    },
    resetSenha() {
      this.$vs.loading();
      service
        .post('Usuario', 'resetar-senha-usuario', {
          emailConsultor: this.userAlteracao.email,
        })
        .then((res) => {
          if (!res.data.length) {
            notify.notifyFail(
              this.$vs,
              'Não foi encontrado nenhum usuário com email informado',
            );
            return;
          }
          notify.notifySuccess(
            this.$vs,
            'Senha temporária enviada para o email do usuário',
          );
          this.userAlteracao = null;
          this.modalSenha = false;
        })
        .catch((e) => notify.notifyFail(this.$vs, e))
        .finally(() => this.$vs.loading.close());
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    updateSelectPagination(value) {
      this.currentPage = 1;
      this.itemsPerPage = value;
    },
    async inativar() {
      if (!this.selected.length) {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
        return;
      }
      const success = await this.handleStatus(false);

      if (success) {
        notify.notifySuccess(this.$vs, 'Registro(s) inativado(s) com sucesso');
        this.buscaDados();
        this.selected = [];
      }
    },
    async reativar() {
      if (!this.selected.length) {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
        return;
      }

      const success = await this.handleStatus(true);

      if (success) {
        notify.notifySuccess(this.$vs, 'Registro(s) reativado(s) com sucesso');
        this.buscaDados();
        this.selected = [];
      }
    },
    async handleStatus(value) {
      try {
        this.$vs.loading();
        const promises = this.selected.map((item) => {
          const payload = {
            id: item.id,
            status: value,
          };
          return service.post('Usuario', 'handle-status', payload);
        });
        await Promise.all(promises);
        return true;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        return false;
      } finally {
        this.$vs.loading.close();
      }
    },
    updateFilters(filters) {
      this.filters = functions.cleanParams(filters);
      this.currentPage = 1;
      this.buscaDados();
    },
    async buscaDados() {
      this.selected = [];
      this.$vs.loading();
      try {
        const response = await userApi.getUsers({
          ...this.filters,
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
        });
        this.itens = response.rows;
        this.count = response.count;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getUserDetails(userId) {
      let userDetails = this.cachedUsersDetails[userId];
      if (!userDetails) {
        userDetails = await this.fetchUserDetails(userId);
        userDetails = this.formataProgramaAfiliados(userDetails);
        this.$set(this.cachedUsersDetails, userId, userDetails);
      }
      return userDetails;
    },
    async openSideBar(userId) {
      const userDetails = userId ? await this.getUserDetails(userId) : {};

      userDetails.idUsuario == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = {
        ...userDetails,
        dominios: { ...this.dominios },
      };
      this.addNewDataSidebar = true;
    },
    openModalSenha(user) {
      this.userAlteracao = user;
      this.modalSenha = true;
    },
    async fetchUserDetails(userId) {
      this.$vs.loading();
      try {
        const res = await service.getAll(this.controllerGeral, {}, userId);
        const element = res.data;

        if (element.Usuarios_Empresa) {
          element.Empresa = element.Usuarios_Empresa.nome;
        }

        if (element.Usuarios_Perfil) {
          element.Perfil = element.Usuarios_Perfil.nomePerfil;
        }

        if (element.Usuarios_Regional) {
          element.Regional = element.Usuarios_Regional.nome;
        }

        if (element.Usuarios_Setor) {
          element.Setor = element.Usuarios_Setor.nomeSetor;
        }

        if (element.idRegional) {
          element.tipoEmpresa = COMPANY_TYPE_LABEL.BROKER;
          element.nomeEmpresa = element.Usuarios_Regional.nome;
        }
        if (element.idDivisao) {
          element.tipoEmpresa = COMPANY_TYPE_LABEL.CONSULTANCY;
          element.nomeEmpresa = element.Usuarios_Divisao.nomeDivisao;
        }
        if (element.idConvenio) {
          element.tipoEmpresa = COMPANY_TYPE_LABEL.COVENANT;
          element.nomeEmpresa = element.Usuarios_Convenio.nome;
        }

        delete element.Usuarios_Empresa;
        delete element.Usuarios_Perfil;
        delete element.Usuarios_Setor;

        return element;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        return null;
      } finally {
        this.$vs.loading.close();
      }
    },
    async opemModal(userId) {
      this.modalSelecionado = [];
      this.popupActive = true;
      const userDetails = await this.getUserDetails(userId);
      Object.keys(userDetails).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: userDetails[element],
          });
      });
    },
    formataProgramaAfiliados(item) {
      if (item.ProgramaAfiliado) {
        item.ProgramaAfiliado = item.ProgramaAfiliado.nome;
      }
      if (item.UsuarioUpline) {
        item.UsuarioUpline = item.UsuarioUpline.nome;
      }
      return item;
    },
    concluido(userId) {
      this.buscaDados();
      this.$delete(this.cachedUsersDetails, userId);
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    openModalCodigoAcesso(accessCode) {
      this.codigoAcesso = accessCode;
      this.modalCodigoAcesso = true;
    },
    abrirModalHistoricoUsuarios(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'usuarios',
          id: item.id,
        },
      ];
      this.nomeHistorico = item.name;
      this.popupAlteracoesActive = true;
    },
    fecharModalHistorico() {
      this.popupAlteracoesActive = false;
    },
    getRegionais() {
      service.getAll('Regional', {}, 'list-escritorios').then((res) => {
        res.data.forEach((element) => {
          this.dominios.escritorios.push({
            id: element.idRegional,
            label: element.nome,
            corretora: element.Corretora,
          });
        });
      });
    },
  },
  mounted() {
    this.buscaDados();
    this.getRegionais();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
